import { ReactNode } from 'react';
import PrismAPI from '@modules/prism-client/types/prism-types';
import parse from 'html-react-parser';

/**
 * @deprecated This function is deprecated. Use `documentToReactTree` from '@tuic/contentful' instead.
 * The API now returns ContentfulDocumentBlock instead of Html type.
 *
 * This function will be removed in a future version.
 */
export const htmlToReactNode = (
  data: PrismAPI.Html | string | undefined,
): ReactNode => {
  if (typeof data === 'undefined') {
    return null;
  }

  if (typeof data === 'string') {
    return data;
  }

  return parse(data.html);
};
